import React from 'react';

import FieldMultiPhone from '../common/FieldMultiPhone';
import FieldMultiValue from '../common/FieldMultiValue';
import FieldAddress from '../common/FieldAddress';

class LeadAddEditContact extends React.Component {

  constructor(props) { super(props); this.state = { inValid: props.inValid }; }

  UNSAFE_componentWillReceiveProps(props) {
    if(JSON.stringify(this.state.inValid) !== JSON.stringify(props.inValid)) {
      this.setState({ ...this.state, inValid: props.inValid ? props.inValid : {} })
    }
  }

  render() {
    const fields = this.props.model.fields;
    const lead = this.props.lead;
    const onValueChange = this.props.onValueChange;
    return (
      <>
        <div className="formhead col-md-12"><h2>Contact Information</h2></div>

        <FieldMultiPhone key="phone" id="phone" field={fields.phone}
          value={lead.phone} onValueChange={onValueChange} inValid={this.state.inValid} />
        
        <FieldMultiValue key="email" id="email" field={fields.email} value={lead.email}
          onValueChange={onValueChange} inValid={this.state.inValid} />
        
        <FieldMultiValue key="site" id="site" field={fields.site} value={lead.site}
          onValueChange={onValueChange} inValid={this.state.inValid} />
          
        <div className="formhead col-md-12"><h2>Address Information</h2></div>
        <FieldAddress key="address" id="address" field={fields.address} value={lead.address}
          onValueChange={onValueChange} inValid={this.state.inValid} />
      </>
    );
  }
}

export default LeadAddEditContact;